import { CarJourneyType } from '../services/carList/carList.types';
import { TBudgetType } from '../interfaces/IFilters';
import { buildParameterizedPathname } from './url.utils';
import { IConfiguratorOption } from '../redux/configurator/configurator.duck.interface';
import router from 'next/router';

export const removeURLParameter = (url: string, parameter: string) => {
    const urlparts = url.split('?');
    if (urlparts.length >= 2) {
        const prefix = encodeURIComponent(parameter) + '=';
        const pars = urlparts[1].split(/[&;]/g);
        for (let i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
};

export const featuresToUrl = (
    pathname: string,
    paymentJourney: TBudgetType,
    carJourney: CarJourneyType,
    { q, exteriorColourSlug, interiorColourSlug, engineGearboxFuelSlug, options }: any
) => {
    const searchParams = new URLSearchParams(q);

    searchParams.delete('reSaveOptionsOnVehicle');

    if (options.length) {
        searchParams.set('options', options);
        searchParams.set('reSaveOptionsOnVehicle', 'true');
    } else {
        searchParams.delete('options');
    }

    const pathParamsObj = { exteriorColourSlug, interiorColourSlug, engineGearboxFuelSlug };

    const query = searchParams.toString();
    let pathnameWithoutOptions = removeURLParameter(pathname, 'options');

    pathnameWithoutOptions = removeURLParameter(pathnameWithoutOptions, 'utm_source');
    pathnameWithoutOptions = removeURLParameter(pathnameWithoutOptions, 'utm_medium');
    pathnameWithoutOptions = removeURLParameter(pathnameWithoutOptions, 'utm_campaign');

    const pathName = `${buildParameterizedPathname(pathnameWithoutOptions, carJourney, pathParamsObj)}`;
    const queryStart = pathName.indexOf('?');

    return {
        pathName: queryStart > 0 ? pathName.substring(0, queryStart) : pathName,
        query: query || '',
    };
};

export const isOptionFromAlreadySelectedPack = (
    optionVal: any,
    carOptions: IConfiguratorOption[],
    selectedOptions: string[]
) => {
    let result = false;
    if (selectedOptions && carOptions) {
        carOptions.map((optionItem) => {
            if (
                optionItem.includedOptionIds &&
                selectedOptions.includes(optionItem.id) &&
                optionItem.includedOptionIds.includes(optionVal.id)
            ) {
                result = true;
            }
        });
    }
    return result;
};
